import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { format } from "date-fns";
import { memo } from "react";
import { OrganizationServiceRow } from "../organizationServicesViewConfig";

export const OrganizationServiceUpdatedCell = memo(
    ({ row }: CellContext<ViewTableFeatures, OrganizationServiceRow, Date>) => (
        <span>{format(row.original.updatedAt, "MMM d, yyyy")}</span>
    ),
);
